import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicySummary: {
        id: 'cep.components.sgCepSideMenu.navigation.PolicySummary',
        defaultMessage: 'Policy summary'
    },
    AmendPolicy: {
        id: 'cep.components.sgCepSideMenu.navigation.AmendPolicy',
        defaultMessage: 'Amend policy'
    },
    Payments: {
        id: 'cep.components.sgCepSideMenu.navigation.Payments',
        defaultMessage: 'Payments'
    },
    Documents: {
        id: 'cep.components.sgCepSideMenu.navigation.Documents',
        defaultMessage: 'My documents'
    },
    Claims: {
        id: 'cep.components.sgCepSideMenu.navigation.Claims',
        defaultMessage: 'How to claim'
    },
    Account: {
        id: 'cep.components.sgCepSideMenu.navigation.Account',
        defaultMessage: 'Policyholder details'
    },
    Faq: {
        id: 'cep.components.sgCepSideMenu.navigation.Faq',
        defaultMessage: 'FAQ'
    }
});
